import { useQuery } from '@tanstack/react-query';

import { IApiError } from '../../../../types';

import { IFetchOrgMembersListData } from '../types';
import { ORGANIZATION_API } from '../organizationAPIClient';

export const QUERY_FETCH_MEMBERS_LIST_KEY = 'fetch-members-list-key';

interface IUseOrganizationDetailsOptions {
  orgId: string;
  onSuccessCallback?: (orgData: IFetchOrgMembersListData) => void;
}

/**
 * This fetches a list of all members in an organization.
 */
export const useMembersListQuery = ({
  orgId,
  onSuccessCallback,
}: IUseOrganizationDetailsOptions) => {
  const { data, isLoading, isError, error, isPaused, refetch } = useQuery({
    // TODO: Add the orgUser to all query caching.
    queryKey: [QUERY_FETCH_MEMBERS_LIST_KEY, orgId],
    networkMode: 'always',
    // retry: true,
    enabled: !!orgId, // Don't fetch if org id is not loaded.
    queryFn: () => ORGANIZATION_API.fetchMembersList(orgId),
    onSuccess: (response) => {
      onSuccessCallback?.(response);
    },
    onError: (err: IApiError) => err,
  });

  return {
    data,
    error,
    isLoading,
    isError,
    isPaused,
    refetch,
  };
};
